<template>
    <div>
        <enps-question
            :key="k"
            class="question"
            v-for="(question, k) in questions"
            :value.sync="question.score"
            :title="question.title"
            :question="question.question"
            :requireComment="question.require_comments"
            :isEnableComments="question.enable_comments"
            :researchId="question.id"
            :submit="submitAnswer"
        />
    </div>
</template>

<script>
import EnpsQuestion from './components/enps'
import i18n from '@/i18n'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import notification, { success, danger } from '@/lib/notification'
import { saveAnswer } from './api'

notification.init()

export default {
    components: {
        EnpsQuestion,
    },
    props: {
        questions: {
            type: Array,
            required: true,
        },
        update: {
            type: Function,
            required: true,
        },
        userId: {
            type: [String, Number],
            required: true,
        },
    },
    methods: {
        submitAnswer(data) {
            proceedWithConfirmation({
                message: i18n.t('notification.sendENPSAnswer'),
                onConfirm: () => saveAnswer(this.userId, data),
                callback: () => {
                    success(i18n.t('notification.answerSentSuccessfully'))
                    this.update()
                },
                onError: () => danger(),
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.question:not(:last-child) {
    margin-bottom: 0.5rem !important;
}
</style>
